import { Component } from '@angular/core';
import { Button } from '../../shared/components/button/button.component';
import { Titledescription } from '../../shared/components/titledescription/titledescription.component';
import { Table } from '../../shared/components/table/table.component';

@Component({
  selector: 'app-modalidades',
  imports: [Button,Titledescription,Table],
  templateUrl: './modalidades.html',
  styleUrl: './modalidades.scss'
})
export class Modalidades {

}
